<div class="flex flex-col h-screen">

  <!-- Header -->
  <div class="px-6 pt-4 pb-2">
    <div class="flex justify-between items-center">
      <div>
        <h1 class="text-2xl font-bold text-gray-800">Clientes</h1>
        <p class="text-sm text-gray-500">Gerencie seu catálogo de clientes</p>
      </div>
      <button (click)="createCustomer()" class="bg-orange-500 hover:bg-orange-600 cursor-pointer text-white px-4 py-2 rounded">
        Novo Cliente
      </button>
    </div>
  </div>

  <!-- Filtros -->
  <div class="px-6 py-4 bg-white shadow shrink-0 z-10">
    <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
      <div class="flex flex-col">
        <label class="text-sm font-medium text-gray-700 mb-1">Código</label>
        <input
          pInputText
          type="text"
          [(ngModel)]="searchCode"
          (input)="onSearchCodeChange()"
          placeholder="Digite o código do cliente..."
          class="w-full text-sm"
        />
      </div>
      <div class="flex flex-col">
        <label class="text-sm font-medium text-gray-700 mb-1">Nome</label>
        <input
          pInputText
          type="text"
          [(ngModel)]="searchName"
          (input)="onSearchNameChange()"
          placeholder="Digite o nome do cliente..."
          class="w-full text-sm"
        />
      </div>
      <div class="flex flex-col">
        <label class="text-sm font-medium text-gray-700 mb-1">CPF</label>
        <input
          pInputText
          type="text"
          [(ngModel)]="searchCpf"
          (input)="onSearchCpfChange()"
          placeholder="Digite o CPF do cliente..."
          class="w-full text-sm"
        />
      </div>
      <div class="flex flex-col">
        <label class="text-sm font-medium text-gray-700 mb-1">Status (receita)</label>
        <p-dropdown
          [options]="statusOptions"
          [(ngModel)]="currentStatus"
          (onChange)="onRevenueStatusChange()"
          optionLabel="label"
          optionValue="value"
          placeholder="Selecione o status"
          class="w-full text-sm"
        ></p-dropdown>
      </div>
      <div class="flex flex-col">
        <label class="text-sm font-medium text-gray-700 mb-1">Ativo / Inativo</label>
        <p-dropdown
          [options]="activeStatusOptions"
          [(ngModel)]="selectedActiveStatus"
          (onChange)="onActiveStatusChange()"
          optionLabel="label"
          optionValue="value"
          placeholder="Selecione"
          class="w-full text-sm"
        ></p-dropdown>
      </div>
      <div class="flex flex-col">
        <label class="text-sm font-medium text-gray-700 mb-1">Estado</label>
        <p-dropdown
          [options]="states"
          [(ngModel)]="selectedState"
          (onChange)="onStateChange()"
          optionLabel="description"
          optionValue="acronym"
          placeholder="Selecione o estado"
          class="w-full text-sm"
        ></p-dropdown>
      </div>
      <div class="flex flex-col">
        <label class="text-sm font-medium text-gray-700 mb-1">Cidade</label>
        <p-dropdown
          [options]="cities"
          [(ngModel)]="selectedCity"
          (onChange)="onCityChange()"
          optionLabel="description"
          optionValue="description"
          placeholder="Selecione a cidade"
          [filter]="true"
          [showClear]="true"
          class="w-full text-sm"
        ></p-dropdown>
      </div>
      <div class="text-sm text-gray-600 flex items-end pb-2">
        {{ totalRecords }} cliente(s) encontrado(s)
      </div>
    </div>
  </div>

  <!-- Conteúdo rolável (igual ao financeiro) -->
  <div class="flex flex-col flex-1 min-h-0 overflow-y-auto pb-10">
    <div class="w-full flex-1 px-6 py-4 bg-gray-50">
    <div class="bg-white shadow rounded overflow-x-auto">
      <p-table 
        [value]="customers" 
        [paginator]="false"
        [loading]="loading"
        styleClass="p-datatable-sm"
        [rowHover]="true"
        [stripedRows]="true"
        stripedRowsClass="bg-orange-50"
        [showCurrentPageReport]="false"
        responsiveLayout="scroll"
        class="min-w-full text-sm">
        <ng-template pTemplate="header">
          <tr class="bg-gray-100">
            <th class="text-left px-3 py-1 text-sm">Código</th>
            <th class="text-left px-3 py-1 text-sm">Nome</th>
            <th class="text-left px-3 py-1 text-sm">Total compras (R$)</th>
            <th class="text-left px-3 py-1 text-sm">Situação (receita)</th>
            <th class="text-left px-3 py-1 text-sm">Ativo</th>
            <th class="text-left px-3 py-1 text-sm">Receitas</th>
            <th class="text-left px-3 py-1 text-sm">Ações</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-customer let-i="rowIndex">
          <tr [ngClass]="i % 2 === 0 ? 'bg-white' : 'bg-orange-50'" class="leading-tight">
            <td class="px-3 py-0 font-mono align-top text-sm">{{ customer.customerId }}</td>
            <td class="px-3 py-0 align-top">
              <div class="font-semibold text-gray-900 leading-tight text-sm">{{ customer.customerName }}</div>
              <div *ngIf="getCustomerAddress(customer)" class="text-xs text-gray-500 leading-tight mt-0.5">
                {{ getCustomerAddress(customer) }}
              </div>
            </td>
            <td class="px-3 py-0 align-top text-sm">R$ {{ customer.totalRevenue | number:'1.2-2' }}</td>
            <td class="px-3 py-0 align-top">
              <p-tag
                [value]="customer.status"
                [severity]="getStatusSeverity(customer.status)"
                [rounded]="false"
                styleClass="text-xs py-0">
              </p-tag>
            </td>
            <td class="px-3 py-0 align-top">
              <p-tag
                [value]="getActiveStatusLabel(customer.activeStatus)"
                [severity]="getActiveStatusSeverity(customer.activeStatus)"
                [rounded]="false"
                styleClass="text-xs py-0">
              </p-tag>
            </td>
            <td class="px-3 py-0 align-top text-sm">{{ customer.revenueCount }}</td>
            <td class="px-3 py-0 align-top">
              <div class="flex space-x-2">
                <p-button
                  pTooltip="Ver Receitas"
                  icon="pi pi-pencil"
                  text
                  severity="secondary"
                  (click)="editCustomer(customer)">
                </p-button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="7" class="text-center py-8 text-gray-500">
              Nenhum cliente encontrado
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <!-- Paginator -->
    <div class="flex justify-center py-4">
      <p-paginator
        [first]="first"
        [rows]="rows"
        [totalRecords]="totalRecords"
        (onPageChange)="onPageChange($event)"
        [showCurrentPageReport]="true"
        [showPageLinks]="true"
        [showFirstLastIcon]="true"
        styleClass="custom-paginator">
      </p-paginator>
    </div>
    </div>
  </div>

  <p-dialog header="Histórico Financeiro" [modal]="true" [(visible)]="showModal">
    <ng-container *ngIf="showModal">
      <app-list-financial-history [customerId]="selectedCustomerId" ></app-list-financial-history>
    </ng-container>
  </p-dialog>

</div>